import * as React from 'react'
import { styles } from './styles.css'
import image from './image.jpg'

export const TailSection: React.FC = () => {
  return (
    <section className={styles.section}>
      <img src={image} />
      <div className={styles.lines}>
        <p className={styles.text}>
          かわいいお花と過ごす時間、
          <br />
          今すぐはじめよう。
        </p>
      </div>
    </section>
  )
}
